import { useState, useEffect, useContext } from "react"
import finnHub from "../apis/finnHub"
import { WatchListContext } from '../context/watchListContext';

export function AutoComplete() {

  const [search, setSearch] = useState('')
  const [results, setResults] = useState([])
  const { addStock } = useContext(WatchListContext)
  
  function renderDropdown() {
    const dropDownClass = search ? "show" : null
    return (
      <ul
        style={{maxHeight:'500px', overflowY: 'scroll', overflowX:'hidden', cursor: 'pointer'}}
        className={`dropdown-menu ${dropDownClass}`}
      >
        {results.map((result) => {
          return (
            <li
              key={result.symbol}
              className="dropdown-item"
              onClick={() => {
                addStock(result.symbol)
                setSearch('')
              }}
            >
              {result.description} ({result.symbol})
            </li>
          )
        })}
      </ul>
    )
  }

  useEffect(() => {
    let isMounted = true
    async function fetchData() {
      try {
        const response = await finnHub.get('/search', {
          params: {q: search}
        })
        isMounted && setResults(response.data.result)
        // console.log(results)
      } catch(err) {

      }
    }
    search.length > 0 ? fetchData() : setResults([])
    return () => (isMounted = false)
  }, [search])

  return (
    <div className="w-50 p-5 rounded mx-auto">
      <div className="form-floating dropdown">
        <input
          style={{backgroundColor: 'rgba(145,158,171,0.04)'}}
          id='search' type='text' className="form-control"
          placeholder="Search" autoComplete="off"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        >
        </input>
        <label htmlFor="search">Search</label>
        {renderDropdown()}
      </div>
    </div>
  )
}
